// Use this for Local Development
 export const WEBSITE_URL = "https://dash.delivor.in"; //without trailing slash
// export const WEBSITE_URL = "https://delivor.teentechies.in"; //without trailing slash
// export const WEBSITE_URL = "http://127.0.0.1:8000"; //without trailing slash
export const ASSET_BASE_URL = "https://delivor-prod-storage.s3.ap-south-1.amazonaws.com";
// export const WEBSITE_URL = "http://localhost:8000";

export const CUSTOMER_SUPPORT_NUMBER = "+919061858565";

export const TAWKTO_PROPERTY_ID = "5e6b32388d24fc2265875756";
export const TAWKTO_WIDGET_ID = "default";


// Comment out the above and Uncomment the below line before building the files for Production
// export const WEBSITE_URL = "https://" + window.location.hostname;
